import {z} from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {jobDbSchema} from './jobDbSchema';

export const jobSchema = jobDbSchema.omit({createdAt: true, updatedAt: true}).extend({
  id: z.string(),
  createdAt: firestoreTimestampToDateSchema,
  updatedAt: firestoreTimestampToDateSchema,
});

export interface Job extends z.infer<typeof jobSchema> {}
